export default __webpack_public_path__ + "media/images/icons/inverse-x-gray-lighter-2ec62df616581880647441e31bfd5f7f.svg";